import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface Props {
  className?: string;
  children: ReactNode;
  variant?: 'plp' | 'watchlist';
}

/**
 * Product grid
 * Each child item should be a `li` element
 */
export const ProductGrid: FC<Props> = ({ children, className, variant = 'plp' }) => (
  <ul className={clsx('ProductGrid', `ProductGrid-${variant}`, className)} data-testid="used-cars-result-grid">
    {children}
  </ul>
);
